<template>
  <div class="user">
    <div class="col-12">
      <div class="row">
        <div class="col-6">
          <h2>User Detail</h2>
        </div>
      </div>
    </div>
    <div class="row" v-if="user">
      <form class="col-12" @submit.prevent="handleSubmit">
        <div class="row">
          <div class="col-2">
            <label for="email">Email:</label>
          </div>
          <div class="col-9">
            <input
              type="text"
              class="form-control"
              id="email"
              ref="user_email"
              name="email"
              autocomplete="username"
              placeholder="email"
              :value="getEmail()"
            />
          </div>
          <div
            v-if="submitted && errors.has('email')"
            class="col-12 invalid-feedback"
          >
            {{ errors.first("email") }}
          </div>
        </div>
        <div class="row">
          <div class="col-2">
            <label for="description">Description:</label>
          </div>
          <div class="col-9">
            <input
              type="text"
              class="form-control"
              id="description"
              ref="user_description"
              autocomplete="name"
              name="description"
              placeholder="description"
              :value="getDescription()"
            />
          </div>
        </div>
        <div class="row" v-show="user != null && user.id < 1">
          <div class="col-2">
            <label for="password">Password:</label>
          </div>
          <div class="col-9">
            <input
              type="password"
              class="form-control"
              id="password"
              autocomplete="new-password"
              ref="user_password"
              name="password"
              placeholder="password"
            />
          </div>
        </div>
      </form>
    </div>
    <div class="row">
      <div class="col-10">
        <button id="new" @click="$emit('new')" class="btn btn-plt">
          New
        </button>
        <button v-if="user" id="save" @click="save" class="btn btn-plt">
          Save
        </button>
      </div>
      <div class="col-2" v-if="user">
        <button
          id="delete"
          v-if="user.active"
          @click="_delete"
          class="btn btn-danger"
        >
          Delete
        </button>
        <button id="delete" v-else @click="_delete" class="btn btn-primary">
          Reactivate
        </button>
      </div>
    </div>
  </div>
</template>

<script>
import { mapActions } from "vuex";

export default {
  name: "UserDetail",
  props: {
    user: {
      type: Object,
      default: null,
    },
  },
  data: () => ({
    submitted: false,
  }),
  methods: {
    ...mapActions("users", ["apiSaveUser", "apiCreateUser"]),
    handleSubmit() {
      this.submitted = true;
      this.$validator.validate().then(valid => {
        if (valid) {
          this.save();
        }
      });
    },
    _delete() {
      if (this.user && this.user.id > 0) {
        this.user.active = !this.user.active;
        this.apiSaveUser(this.user);
      }
    },
    save() {
      if (this.user) {
        this.user.name = this.$refs.user_email.value;
        this.user.description = this.$refs.user_description.value;

        if (this.user.id > 0) {
          this.apiSaveUser(this.user);
        } else {
          this.user.password = this.$refs.user_password.value;
          this.apiCreateUser(this.user);
        }
        this.$emit("saved");
      }
    },
    getEmail() {
      if (this.user == null) {
        return "";
      } else {
        return this.user.email;
      }
    },
    getDescription() {
      if (this.user == null) {
        return "";
      } else {
        return this.user.description;
      }
    },
  },
  components: {},
};
</script>
